// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:32
import { CTacticalSituationHistory_abstract } from './../../abstract/SagaSchema/History/CTacticalSituationHistory_abstract';
export class CTacticalSituationHistory extends CTacticalSituationHistory_abstract {}
